<script setup lang="ts">
import Card from "primevue/card";
</script>
<template>
    <Card>
        <template #header>
            <slot name="header" />
        </template>
        <template #title>
            <slot name="title"></slot>
        </template>
        <template #subtitle>
            <slot name="subtitle"></slot>
        </template>
        <template #content>
            <slot />
            <slot name="content"></slot>
        </template>
        <template #footer>
            <slot name="footer" />
        </template>
    </Card>
</template>
<style scoped></style>
